/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
3/26/2020
Tree Inventory View
**********************************************************/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchFields, fetchEmployees, clearForm } from '../../actions/utils_actions';
import { addEmployee, removeEmployee, prepareReplant, fetchReplants, 
  createReplant, setReplantToEdit, addEmployeeToEdit, removeEmployeeFromEdit,
  editReplant, setReplantToDelete, deleteReplant } from '../../actions/tree_replant_actions';
import TreeReplantForm from './tree_replant_form';
import TreeReplantDisplay from './tree_replant_display';
import CultivationModal from '../cult_modal';
import EmployeeList from '../../../components/employee_list';
import TreeReplantTable from './tree_replant_table';
import { AutoComplete } from '../inputs';
import { findEmployeeByName } from '../../../utils';
import { mapEmployeeForAutoComplete, packageForm, filterArrayByPropAndValue } from '../../cult_utils'; 
const $ = window.$;

const propTypes = {
  employees: PropTypes.array,
  fields: PropTypes.array,
  inventoryTransactions: PropTypes.array,
  prevReplants: PropTypes.array,
  replants: PropTypes.array,
  user: PropTypes.object,
  clearForm: PropTypes.func,
  addEmployee: PropTypes.func,
  addEmployeeToEdit: PropTypes.func,
  createReplant: PropTypes.func,
  deleteReplant: PropTypes.func,
  editReplant: PropTypes.func,
  fetchEmployees: PropTypes.func,
  fetchFields: PropTypes.func,
  fetchReplants: PropTypes.func,
  prepareReplant: PropTypes.func,
  removeEmployee: PropTypes.func,
  removeEmployeeFromEdit: PropTypes.func,
  setReplantToEdit: PropTypes.func,
  setReplantToDelete: PropTypes.func
};

class TreeReplant extends Component {
  componentDidMount() {
    $('#tree-replant-nav').tabs();
    if (this.props.employees.length === 0) this.props.fetchEmployees();
    if (this.props.replants.length === 0) this.props.fetchReplants();
  }
  render() {
    return (
      <div className="row chemical-reports-view">
        <ul id="tree-replant-nav" className="tabs tabs-fixed-width">
          <li className="tab col s3"><a className="active chemical-tab-nav" href="#recentReplants">Recent Replants</a></li>
          <li className="tab col s3"><a className="chemical-tab-nav" href="#createReplant">Create Replant Log</a></li>
        </ul>
        <div id="recentReplants">
          <div className="col s12 m12 l12 xl12">
          <div className="card harvest-scrollable">
            <div className="harvest-form-card">
              <TreeReplantTable replants={this.props.replants} fields={this.props.fields} employees={filterArrayByPropAndValue(this.props.employees, 'employeeStatus', 'Active')} 
                inventoryTransactions={this.props.inventoryTransactions} addedEmployees={this.props.addedEditEmployees} user={this.props.user}
                editing={this.props.editing} addEmployeeToEdit={this.props.addEmployeeToEdit} removeEmployeeFromEdit={this.props.removeEmployeeFromEdit} 
                fetchFields={this.props.fetchFields} setReplantToEdit={this.props.setReplantToEdit} editReplant={this.props.editReplant}
                setReplantToDelete={this.props.setReplantToDelete} deleteReplant={this.props.deleteReplant}
              />
              </div>
            </div>
          </div>
        </div>
        <div id="createReplant">
          <div className="col s12 m2 l2 xl2">
            <AutoComplete id={'treeReplant-employee'} label={'Employee'}
              data={mapEmployeeForAutoComplete(filterArrayByPropAndValue(this.props.employees, 'employeeStatus', 'Active'))} 
              onComplete={(val, id) => this.props.addEmployee(findEmployeeByName(val, this.props.employees), id)} />
            <div className="emp-list">
              <div className="card">
                <EmployeeList employees={filterArrayByPropAndValue(this.props.employees, 'employeeStatus', 'Active')} icon={'person_add'} header={'Add Employees'} onClick={this.props.addEmployee} _class={'green'} />
              </div>
            </div>
          </div>
          <div className="col s12 m10 l10 xl10">
            <TreeReplantForm formId={'tree-replant-form'} fields={this.props.fields} employees={this.props.employees} 
              inventoryTransactions={this.props.inventoryTransactions} addedEmployees={this.props.addedEmployees}
              inputId={0} removeEmployee={this.props.removeEmployee} fetchFields={this.props.fetchFields}  />
          </div>
          <div className="col s12">
            <div className="card-footer">
              <a className="waves-effect waves-light btn modal-trigger" href={'#tree-inventory-prepare'}
                onClick={() => this.props.prepareReplant({
                  user: this.props.user,
                  form: packageForm('tree-replant-form'),
                  inventoryTransactions: this.props.inventoryTransactions
                })}>
                Prepare
              </a>
              <button className="btn btn-flat"
                onClick={() => this.props.clearForm('tree-replant-form')}>Clear</button>
            </div>
          </div>
          <div className="col s12">
          {
            CultivationModal(TreeReplantDisplay)
            // eslint-disable-next-line
            ({
              id: 'tree-inventory-prepare',
              data: this.props.app,
              employees: this.props.employees,
              inventoryTransactions: this.props.inventoryTransactions,
              prevReplants: this.props.prevReplants,
              toDelete: false, 
              editingApplication: false,
              footer: true,
              createOrEdit: true,
              onClick: () => this.props.createReplant({data: this.props.app, formId: 'tree-replant-form' })
            })
          }
          </div>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    app: state.cultivation.treeReplant.app,
    addedEmployees: state.cultivation.treeReplant.app.addedEmployees,
    addedEditEmployees: state.cultivation.treeReplant.edit.addedEmployees,
    editing: state.cultivation.treeReplant.editing,
    employees: state.cultivation.utils.employees,
    fields: state.cultivation.utils.fields,
    inventoryTransactions: state.cultivation.treeInventory.inventoryTransactions,
    prevReplants: state.cultivation.treeReplant.app.prevReplants,
    replants: state.cultivation.treeReplant.replants,
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    addEmployee,
    addEmployeeToEdit,
    clearForm,
    createReplant,
    deleteReplant,
    editReplant,
    fetchEmployees,
    fetchFields,
    fetchReplants,
    prepareReplant,
    removeEmployee,
    removeEmployeeFromEdit,
    setReplantToDelete,
    setReplantToEdit
  }, dispatch);
}

TreeReplant.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(TreeReplant);



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/tree_replant/tree_replant.js